import React from 'react';

export const Missing = () => {
  return <div>MissingView</div>;
};
